module.exports = __webpack_public_path__ + "img/Caravan-trailer-pen-holder-1-thumb.jpg";